import { useEffect, useState } from "react";
import {
  Form,
  useActionData,
  useNavigate,
  useNavigation,
} from "react-router-dom";

import { Button } from "@/components/clickable";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "@/components/dialog";
import { Input } from "@/components/input";
import { HStack, VStack } from "@/components/layout";
import { isSubmitting } from "@/utils/react-router-fetcher";

export default function CreateView() {
  const { state } = useNavigation();
  const navigate = useNavigate();
  const data = useActionData();
  const errors = data?.errors;

  let [isOpen, setIsOpen] = useState(true);

  const close = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isOpen) navigate("/");
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      as="div"
      size="lg"
      className="relative z-10 shadow-2xl ring-0 focus:outline-none"
      onClose={close}
      __demoMode
    >
      <DialogTitle as="h3" className="text-base/7 font-medium text-black">
        Create a new project
      </DialogTitle>
      <DialogDescription className="mt-2 text-sm/6">
        This will contain a single client’s financial PDF documents for
        transformation and enrichment
      </DialogDescription>
      <Form method="post">
        <DialogBody>
          <VStack>
            <p className="text-xs font-medium text-zinc-600">Project Name</p>
            <Input
              name="name"
              className="bg-transparent"
              placeholder="Enter project name here"
            />
            {errors?.name && <span>{errors.name}</span>}
          </VStack>
        </DialogBody>
        <DialogActions>
          <HStack className="w-full justify-end">
            <Button
              onClick={close}
              color="white"
              className="border-none"
              disabled={isSubmitting(state)}
            >
              Cancel
            </Button>
            <Button type="submit" isLoading={isSubmitting(state)}>
              Create project
            </Button>
          </HStack>
        </DialogActions>
      </Form>
    </Dialog>
  );
}
